// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperNewsStory-cls1_DfU","cls2":"MultiPaperNewsStory-cls2__uL MultiPaperNewsStory-cls1_DfU"};